import { TUOLEN_BRAND } from '@cartiq/shared/brand';
import { cn } from '../../lib/utils';

interface LogoProps {
  className?: string;
  mark?: boolean;
  /** Use the white mark and wordmark on a dark background. */
  dark?: boolean;
}

export function Logo({ className, mark = false, dark = false }: LogoProps) {
  return (
    <span
      role="img"
      aria-label={TUOLEN_BRAND.fullName}
      className={cn('inline-flex shrink-0 items-center gap-2.5', className)}
    >
      <img
        src={dark ? TUOLEN_BRAND.assets.markWhite : TUOLEN_BRAND.assets.mark}
        alt=""
        aria-hidden="true"
        width={32}
        height={32}
        className="h-8 w-8 shrink-0 object-contain"
      />
      {!mark && (
        <span aria-hidden="true" className="flex flex-col">
          <span className={cn('text-lg font-bold leading-5 tracking-tight', dark ? 'text-white' : 'text-primary')}>
            {TUOLEN_BRAND.name}
          </span>
          <span className={cn('text-[10px] font-medium leading-3', dark ? 'text-white/80' : 'text-mid')}>
            by {TUOLEN_BRAND.parentName}
          </span>
        </span>
      )}
    </span>
  );
}
